import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Tag, Map, ShieldCheck, LayoutDashboard, Building2, User, CreditCard, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

function spaceTab(user) {
  if (!user || user === false) return { to: "/connexion", label: "Connexion", Icon: LogIn, match: "/connexion" };
  switch (user.role) {
    case "admin":
    case "super_admin": return { to: "/admin", label: "Admin", Icon: ShieldCheck, match: "/admin", space: true };
    case "professional": return { to: "/pro", label: "Espace Pro", Icon: LayoutDashboard, match: "/pro", space: true };
    case "organization": return { to: "/organisme", label: "Organisme", Icon: Building2, match: "/organisme", space: true };
    case "member": return { to: "/mon-pass", label: "Mon pass", Icon: CreditCard, match: "/mon-pass", space: true };
    default: return { to: "/compte", label: "Compte", Icon: User, match: "/compte", space: true };
  }
}

export default function MobileTabBar() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [badge, setBadge] = useState(0);

  useEffect(() => {
    if (!user || user === false) { setBadge(0); return; }
    let active = true;
    const load = () => api.get("/me/espace-badge").then((r) => { if (active) setBadge(r.data?.count || 0); }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { active = false; clearInterval(t); };
  }, [user, pathname]);

  const tabs = [
    { to: "/", label: "Accueil", Icon: Home, match: "/", exact: true },
    { to: "/bons-plans", label: "Bons plans", Icon: Tag, match: "/bons-plans" },
    { to: "/carte", label: "Carte", Icon: Map, match: "/carte" },
    spaceTab(user),
  ];

  const isActive = (t) =>
    t.exact ? pathname === "/" : pathname === t.match || pathname.startsWith(t.match + "/");

  // Masquer la barre d'onglets sur la page publique d'une carte (plein écran autonome)
  if (/^\/carte\/[^/]+/.test(pathname)) return null;

  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur border-t border-slate-200 pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-tabbar"
    >
      <div className="grid grid-cols-4">
        {tabs.map((t) => {
          const active = isActive(t);
          const Icon = t.Icon;
          const showBadge = t.space && badge > 0;
          return (
            <Link
              key={t.to + t.label}
              to={t.to}
              data-testid={`tabbar-${t.match === "/" ? "home" : t.match.replace(/\//g, "")}`}
              className={`relative flex flex-col items-center justify-center gap-0.5 py-2 transition-colors ${
                active ? "text-[#E05638]" : "text-slate-500 hover:text-slate-700"
              }`}
            >
              <span className="relative">
                <Icon size={20} />
                {showBadge && (
                  <span
                    data-testid="tabbar-espace-badge"
                    className="absolute -top-1.5 -right-2 min-w-[16px] h-[16px] px-1 grid place-items-center rounded-full bg-[#E05638] text-white text-[9px] font-bold leading-none ring-2 ring-white"
                  >
                    {badge > 9 ? "9+" : badge}
                  </span>
                )}
              </span>
              <span className="text-[10px] font-semibold leading-none">{t.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
